// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-pie {
  display: grid;
  align-items: center;
  column-gap: 24px;
  --v-pie-size: 250px;
}
:where(.vuetify-styles) .v-pie--legend-top {
  grid-template-areas: "title" "legend" "content";
  grid-template-columns: var(--v-pie-size);
}
:where(.vuetify-styles) .v-pie--legend-bottom {
  grid-template-areas: "title" "content" "legend";
  grid-template-columns: var(--v-pie-size);
}
:where(.vuetify-styles) .v-pie--legend-right {
  grid-template-areas: "title ." "content legend";
}
:where(.vuetify-styles) .v-pie--legend-left {
  grid-template-areas: ". title" "legend content";
}
:where(.vuetify-styles) .v-pie--legend-hidden {
  grid-template-areas: "title" "content";
}
:where(.vuetify-styles) .v-pie__title {
  grid-area: title;
  text-align: center;
  padding-bottom: 12px;
}
:where(.vuetify-styles) .v-pie__content {
  grid-area: content;
  position: relative;
  width: var(--v-pie-size);
  height: var(--v-pie-size);
}
:where(.vuetify-styles) .v-pie__content:is(.v-pie__content) {
  background: none !important;
}
:where(.vuetify-styles) .v-pie__content .v-overlay .v-overlay__scrim,
:where(.vuetify-styles) .v-pie__content .v-overlay .v-overlay__content {
  pointer-events: none !important;
}
:where(.vuetify-styles) .v-pie__segments {
  border-radius: 50%;
}
:where(.vuetify-styles) .v-pie__content-underlay {
  border-radius: 50%;
  position: absolute;
  inset: -8px;
  pointer-events: none;
  z-index: -1;
}
:where(.vuetify-styles) .v-pie__center-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
:where(.vuetify-styles) .v-pie__center-content > div {
  pointer-events: auto;
}
:where(.vuetify-styles) .v-pie__legend {
  grid-area: legend;
  padding-block: 12px;
}
:where(.vuetify-styles) .v-pie__legend .v-avatar {
  border: thin solid rgba(var(--v-theme-on-surface), 0.2);
}
:where(.vuetify-styles) .v-pie__legend .v-chip__content {
  width: 100%;
}
:where(.vuetify-styles) .v-pie__legend .v-chip-group .v-chip:not(.v-chip--selected) {
  opacity: 0.4;
}
:where(.vuetify-styles) .v-pie__legend__text {
  font-size: 0.8125rem;
  white-space: nowrap;
  width: 100%;
}
:where(.vuetify-styles) .v-chip--density-compact .v-pie__legend__text {
  font-size: 0.66rem;
}
:where(.vuetify-styles) .v-pie .v-chip.v-chip--density-comfortable .v-avatar--start {
  margin-inline-start: -6px;
}
:where(.vuetify-styles) .v-pie .v-chip.v-chip--density-default .v-avatar--start {
  margin-inline-start: -4px;
}
:where(.vuetify-styles) .v-pie-segment {
  pointer-events: none;
  position: absolute;
  inset: 0;
}
:where(.vuetify-styles) .v-pie-segment .v-pie-segment__overlay {
  pointer-events: auto;
  opacity: 0;
}
:where(.vuetify-styles) .v-pie__tooltip-content .v-list-item {
  padding-inline: 0;
  min-width: 100px;
  zoom: 0.88;
}
:where(.vuetify-styles) .v-pie__tooltip-content .v-list-item-subtitle {
  opacity: 1;
}
:where(.vuetify-styles) .v-pie__tooltip-content .v-avatar {
  border: thin solid rgba(var(--v-theme-on-surface-variant), 0.2);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/labs/VPie/VPie.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,uDAAuD;AACzD;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,+DAA+D;AACjE","sourcesContent":[".v-pie {\n  display: grid;\n  align-items: center;\n  column-gap: 24px;\n  --v-pie-size: 250px;\n}\n.v-pie--legend-top {\n  grid-template-areas: \"title\" \"legend\" \"content\";\n  grid-template-columns: var(--v-pie-size);\n}\n.v-pie--legend-bottom {\n  grid-template-areas: \"title\" \"content\" \"legend\";\n  grid-template-columns: var(--v-pie-size);\n}\n.v-pie--legend-right {\n  grid-template-areas: \"title .\" \"content legend\";\n}\n.v-pie--legend-left {\n  grid-template-areas: \". title\" \"legend content\";\n}\n.v-pie--legend-hidden {\n  grid-template-areas: \"title\" \"content\";\n}\n.v-pie__title {\n  grid-area: title;\n  text-align: center;\n  padding-bottom: 12px;\n}\n.v-pie__content {\n  grid-area: content;\n  position: relative;\n  width: var(--v-pie-size);\n  height: var(--v-pie-size);\n}\n.v-pie__content:is(.v-pie__content) {\n  background: none !important;\n}\n.v-pie__content .v-overlay .v-overlay__scrim,\n.v-pie__content .v-overlay .v-overlay__content {\n  pointer-events: none !important;\n}\n.v-pie__segments {\n  border-radius: 50%;\n}\n.v-pie__content-underlay {\n  border-radius: 50%;\n  position: absolute;\n  inset: -8px;\n  pointer-events: none;\n  z-index: -1;\n}\n.v-pie__center-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n.v-pie__center-content > div {\n  pointer-events: auto;\n}\n.v-pie__legend {\n  grid-area: legend;\n  padding-block: 12px;\n}\n.v-pie__legend .v-avatar {\n  border: thin solid rgba(var(--v-theme-on-surface), 0.2);\n}\n.v-pie__legend .v-chip__content {\n  width: 100%;\n}\n.v-pie__legend .v-chip-group .v-chip:not(.v-chip--selected) {\n  opacity: 0.4;\n}\n.v-pie__legend__text {\n  font-size: 0.8125rem;\n  white-space: nowrap;\n  width: 100%;\n}\n.v-chip--density-compact .v-pie__legend__text {\n  font-size: 0.66rem;\n}\n.v-pie .v-chip.v-chip--density-comfortable .v-avatar--start {\n  margin-inline-start: -6px;\n}\n.v-pie .v-chip.v-chip--density-default .v-avatar--start {\n  margin-inline-start: -4px;\n}\n.v-pie-segment {\n  pointer-events: none;\n  position: absolute;\n  inset: 0;\n}\n.v-pie-segment .v-pie-segment__overlay {\n  pointer-events: auto;\n  opacity: 0;\n}\n.v-pie__tooltip-content .v-list-item {\n  padding-inline: 0;\n  min-width: 100px;\n  zoom: 0.88;\n}\n.v-pie__tooltip-content .v-list-item-subtitle {\n  opacity: 1;\n}\n.v-pie__tooltip-content .v-avatar {\n  border: thin solid rgba(var(--v-theme-on-surface-variant), 0.2);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
